import React from "react";
import { useLocation } from "react-router-dom";

export function parseCompanyIdFromSearch(search: string): number {
  const params = new URLSearchParams(search);
  const raw = params.get("companyId");
  const parsed = raw ? Number.parseInt(raw, 10) : NaN;
  return Number.isFinite(parsed) ? parsed : NaN;
}

export function useCompanyIdFromSearch(): number {
  const { search } = useLocation();
  return React.useMemo(() => parseCompanyIdFromSearch(search), [search]);
}
